import { CompanyContext } from "contexts/CompanyContext";
import React, { useContext } from "react";
import { formatNumber } from "utils/formatNumber";
import { FaGlobeAmericas } from "react-icons/fa";
import TextPreview from "./components/TextPreview";
import MediaPreview from "./components/MediaPreview";
import AddAssetButton from "./components/AddAssetButton";
import CommentSection from "./components/CommentsSection"


const FacebookPreview = (post) => {

    const {
        id,
        user_id,
        user_name,
        username,
        user_image,
        created_at,
        text,
        media,
        like_count,
        comment_count,
        view_count,
        retweet_count,
        className,
        imgClassName,
        assets,
        preferences,

        postIndex,
        isEditable,
        onAssetDelete,
        onAssetEdit,
        onAssetNew,
        onTextEdit, 
        onCreateNetworkPost,
        onDeleteIndexPost,
        allPosts = [],
        isSimpleView,
    } = post;

    const network = "facebook";
    const { company, companySocials } = useContext(CompanyContext);
    const integration = companySocials?.filter(e => e.type == "facebook")?.[0];
   
    if (!!preferences?.media_product_type && preferences?.media_product_type != "FEED" && preferences?.media_product_type != "REEL") return <></>;

    return (
        <div className={`instagram rounded-2xl flex flex-col ${className}`}>
            <div className="flex items-center justify-between w-full p-4 py-3">
                <div className="flex items-center gap-3">
                    <img src={user_image || integration?.image?.url || company?.image?.url || `/img/socials-rounded/${network}.svg`} className="rounded-full h-10 w-10" />
                    <div className="flex flex-col w-full">
                        <span className="!text-sm font-bold text-tertiary-700 dark:text-gray-100">{user_name || integration?.name || company?.name}</span>
                        <span className="!text-xs font-light">{new Date(created_at ? created_at : new Date()).getDate()} {new Date(created_at ? created_at : new Date()).toLocaleString('default', { month: 'short' })} · <FaGlobeAmericas className="inline-block -mt-[2px]" /></span>
                    </div>
                </div>
            </div>
            <div className="px-4 pb-2">
                <TextPreview 
                    text={text} 
                    network={network} 
                    isEditable={isEditable && !isSimpleView}
                    post={post}
                    onTextEdit={(value) => onTextEdit(postIndex, value)}
                />
            </div>
            {!!assets?.length && 
                <div className="w-full grid grid-cols-2">
                    {assets?.map((asset, key) => (
                        <MediaPreview 
                            key={key}
                            asset={asset} 
                            parentClassName={`${assets?.length%2 == 1 && key == 0 ? `${assets?.length > 1 ? `aspect-[16/10]` : `!aspect-auto`} col-span-2` : `aspect-square`}`}
                            className={`w-full h-full object-cover`} 
                            network={network}
                            isEditable={isEditable && !isSimpleView}
                            onAssetDelete={() => onAssetDelete(postIndex, key)}
                            onAssetEdit={(src) => onAssetEdit(postIndex, key, src)}
                        />
                    ))}
                </div>
            }
            {isEditable && !isSimpleView && 
                <div className="px-4 py-2">
                    <AddAssetButton 
                        network={network}
                        onAssetNew={(asset) => onAssetNew(postIndex, asset)}
                        onAssetDelete={(assetIndex) => onAssetDelete(postIndex, assetIndex)}
                        post={post}
                        allPosts={allPosts}
                    />
                </div>
            }
            <div className="flex items-center justify-between w-full p-4 py-3">
                <div className="flex gap-0 items-center relative z-[0]">
                    <img src="/img/facebook/like.svg" className="w-6 h-6 rounded-full border-2 border-white z-[1] relative inline-block" />
                    <img src="/img/facebook/heart.svg" className="w-6 h-6 rounded-full border-2 border-white -ml-2 relative inline-block" />
                    {like_count > 0 && <span className="!text-sm text-tertiary-700 ml-2">{formatNumber(like_count, 0)}</span>}
                </div>
                <div className="flex gap-5">
                    {comment_count > 0 ? <span className="!text-sm text-tertiary-700">{comment_count} comments</span> : <></>}
                    {retweet_count > 0 ? <span className="!text-sm text-tertiary-700">{retweet_count} times shared</span> : <></>}
                </div>
            </div>
            <CommentSection 
                post={post}
                network={network}
                integration={integration}
                company={company}
            />
        </div>
    )
}

export default FacebookPreview;